// extracted by mini-css-extract-plugin
export var fadeIn = "_fg-1";
export var modalContent = "_fg-3";
export var overlay = "_fg-0";
export var popoverContent = "_fg-2";
export var results = "_fg-5";
export var searchInputWrapper = "_fg-4";